import $ from 'jquery'

$('.two-friends-read-more').on('click', (e) => {
    const $this = $(e.currentTarget)
    $this.prev().toggleClass('extend')
})